import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Spin, Button, Table, Space, Drawer, message, Input } from "antd";
import get from "lodash/get";
import assign from "lodash/assign";
import debounce from "lodash/debounce";

import {  SearchOutlined } from "@ant-design/icons";

import requireAuth from "../../hocs/requireAuth";

import { companyColumns } from "../../constants/tableColumns/companies";
import {
  deleteCompany,
  fetchCompanies,
} from "../../redux/actions/companyActions";
import { DELETE_COMPANY_SUCCESS } from "../../constants/message";
import { fetchConfig } from "../../redux/actions/authActions";
import AddEditCompany from "../../components/companies/addEditCompany";
import { SUPER_ADMIN_ROLE_ACCESS } from "../../constants";

const CompanySettingsScreen = () => {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [companyForm, setCompanyForm] = useState({
    visible: false,
    data: null,
    edit: false,
  });

  const toggleCompanyForm = (data = null, edit = false) => {
    assign(companyForm, {
      visible: !get(companyForm, "visible"),
      data,
      edit,
    });
    setCompanyForm({ ...companyForm });
  };

  const [companies, setCompanies] = useState({ data: [], query: '' });

  const [config, setConfig] = useState(undefined);

  const getConfig = () => {
    dispatch(fetchConfig("templates,feature_permissions"))
      .then((result) => {
        setConfig(result);
      })
      .catch(() => { });
  };

  const getCompanies = (query = '') => {
    setLoading(true);
    if (!query && inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.focus();
    }

    dispatch(fetchCompanies(query))
      .then((result) => {
        setLoading(false);
        setCompanies({ query: query, data: result });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onDeleteCompany = (id) => {
    setLoading(true);
    dispatch(deleteCompany(id))
      .then(() => {
        getCompanies();
        message.success(DELETE_COMPANY_SUCCESS);
      })
      .catch(() => {
        setLoading(false);
      });
  };



  const onSearchCompanies = debounce((query) => {
    getCompanies(query);
  }, 500);

  useEffect(() => {
    getCompanies();
    getConfig();
  }, []);
  return (
    <div className="pl-2 py-2 h-full flex flex-col">
      <div className="flex flex-row justify-between pb-4">
        <div>
          <p className="text-xl font-medium leading-[30px] text-black-1">
            Companies
          </p>
        </div>
        <div>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                toggleCompanyForm();
              }}
            >
              Add Company
            </Button>
          </Space>
        </div>
      </div>

      <div className="h-full rounded-xl overflow-hidden bg-white flex-1 overflow-y-auto scrollbar-hidden pb-5 min-w-full ">
        <div className="w-full px-8 py-6">
          <div className="justify-end flex items-center h-full space-x-5 ">
            <Input
              style={{
                width: 200,
              }}
              ref={inputRef}
              onChange={(val) => {
                onSearchCompanies({
                  query: val.target.value,
                });
              }}
              size="middle"
              placeholder="Search Company"
              onClear={() => {
                getCompanies({
                  query: '',
                });
              }}
              allowClear
              prefix={<SearchOutlined className="mr-2 text-gray-400" />}
            />
          </div>
        </div>
        <div className="px-8 py-4 overflow-y-auto">
          <Spin spinning={loading}>
            <Table
              columns={companyColumns(toggleCompanyForm, onDeleteCompany)}
              dataSource={get(companies, "data")}
             rowKey={(record) => get(record, "id") || crypto.randomUUID()}
            />
          </Spin>
        </div>
      </div>

      <Drawer
        destroyOnHidden={true}
        title={get(companyForm, "edit") ? "Edit Company" : "Add Company"}
        width={"85%"}
        classNames={"bg-yellow-100"}
        onClose={() => {
          toggleCompanyForm();
        }}
        height
        open={get(companyForm, "visible")}
      >
        <AddEditCompany
          refresh={getCompanies}
          toggle={toggleCompanyForm}
          data={get(companyForm, "data")}
          edit={get(companyForm, "edit")}
          config={config}
        />
      </Drawer>
    </div>
  );
};

export default requireAuth(CompanySettingsScreen, SUPER_ADMIN_ROLE_ACCESS);
